/**
 * @generated SignedSource<<1c1eafb6c2e1837f3fb1b0844562f761>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleDateContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"defaultArticleDateContent">;
  readonly " $fragmentType": "articleDateContent";
};
export type articleDateContent$key = {
  readonly " $data"?: articleDateContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleDateContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleDateContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "defaultArticleDateContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "ce7d17033301194bdcbf8a47f03a34e4";

export default node;
